import { resolveComponent } from "./componentLoader";

// 把后端 /auth/menu/routers 的树 flatten 成 vue-router 需要的 RouteConfig 列表。
// 忽略:
//   - 没 path 或 path 为空的节点 (BUTTON 类型)
//   - component 后端没配、或前端 componentLoader 里找不到的节点 (仍作为父容器,
//     但不建路由,避免 blank 页)
//
// 每条路由用后端 menu.id 拼一个稳定 name,方便未来 removeRoute / keep-alive 缓存 key。
export function buildRoutes(menuTree) {
  const routes = [];
  const walk = (nodes) => {
    if (!Array.isArray(nodes)) return;
    for (const node of nodes) {
      if (!node) continue;
      if (node.menuType === "DIR" && node.path) {
        const landingPath = firstPagePath(node);
        // Some legacy DIR nodes deliberately share their path with the first
        // MENU page. Only add a redirect when the directory has its own URL.
        if (landingPath && landingPath !== node.path) {
          routes.push({
            path: node.path,
            name: `${routeName(node)}_dir`,
            redirect: landingPath,
            meta: {
              title: node.name,
              menuId: node.id,
            },
          });
        }
      }
      if (node.menuType === "MENU" && node.path && node.component) {
        const loader = resolveComponent(node.component);
        if (loader) {
          routes.push({
            path: node.path,
            name: routeName(node),
            component: loader,
            meta: {
              title: node.name,
              // perms 可以是字符串或数组(OR 匹配),router beforeEach 会做校验。
              perm: node.perms || undefined,
              menuId: node.id,
            },
          });
        }
      }
      if (node.children && node.children.length) walk(node.children);
    }
  };
  walk(menuTree);
  return routes;
}

function firstPagePath(node) {
  if (!node || !Array.isArray(node.children)) return "";
  for (const child of node.children) {
    if (child && child.menuType === "MENU" && child.path && child.component) {
      return child.path;
    }
    const descendantPath = firstPagePath(child);
    if (descendantPath) return descendantPath;
  }
  return "";
}

function routeName(node) {
  // 用 id 做前缀保证唯一;name 主要给 keep-alive / addRoute 后期定位用。
  return `m${node.id}`;
}
